import Decimal from 'decimal.js'

// Configure Decimal.js for high precision
// Note: This creates a Decimal constructor with isolated config to avoid affecting global state
export const AniDecimal = Decimal.clone({
  precision: 50,
  rounding: Decimal.ROUND_DOWN,
})

// Buffer amount for rounding (0.01 hyUSD in wei)
export const HYUSD_BUFFER = '10000000000000000' // 0.01 * 1e18

// Max uint256 for infinite threshold
export const MAX_UINT256 = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'

// High usdqThreshold for BUY direction ($1B in wei - 18 decimals)
// Per Florian: use a very high number instead of MAX_UINT256 to avoid contract reverts
export const HIGH_USDQ_THRESHOLD = '1000000000000000000000000000' // 1e27 = $1B

// Standard 18 decimal multiplier (1e18)
export const ONE_E18 = '1000000000000000000'
